export const isDisplayExpertRecommendLabel = (date: Date) => {
  const diffTime = new Date().getTime() - date.getTime();
  const oneHourSeconds = 60 * 60 * 1000;
  if (oneHourSeconds > diffTime) {
    return true;
  }
  const diffInHours = diffTime / oneHourSeconds;
  // 48時間以上前の場合は表示しない
  return diffInHours < 48;
};
